import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const publicGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
  const authToken = localStorage.getItem('authToken');
  const workspaceToken = localStorage.getItem('workspace_token');

  if (!authToken) {
    // Not logged in → allow access to public routes
    return true;
  } else {
    // Logged in → decide based on workspace token
    if (workspaceToken) {
      // User has workspace → redirect to default workspace page
      return router.createUrlTree(['/workspace/choose']); 
    } else {
      // User logged in but has NO workspace → redirect to create workspace
      return router.createUrlTree(['/workspace/create']);
    }
  }
};
